import { Link } from 'react-router-dom'

import * as ROUTES from 'src/constants/routes'
import LogoImage from 'src/assets/logos/logo_footer.svg'
import { StyledLogo } from './styled'

export const Logo = () => (
  <Link to={ROUTES.HOME}>
    <StyledLogo src={LogoImage} alt="ConnectUp Logo" />
  </Link>
)
